// @flow
import type {Node} from 'react';
import type {Parcel} from 'react-dataparcels';

import React from 'react';

type Props = {
    parcel: Parcel
};

const InvalidField =  (props: Props): Node => {
    let {parcel} = props;
    if(!parcel.meta.invalid) {
        return null;
    }
    return <p className="BlueflagAuthFormText BlueflagAuthFormText-negative">{parcel.meta.invalid}</p>;
};


export default InvalidField;